import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Smoothly scroll to hash target on route change / hash change.
export default function ScrollToHash() {
    const { pathname, hash, key } = useLocation();

    useEffect(() => {
        if (hash) {
            // Allow DOM to render the target section before scrolling.
            const id = hash.replace("#", "");
            const tick = () => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                } else {
                    setTimeout(tick, 80);
                }
            };
            setTimeout(tick, 60);
        } else {
            window.scrollTo({ top: 0, behavior: "instant" });
        }
    }, [pathname, hash, key]);

    return null;
}
